import { FinanceIcon } from './FinanceIcon';

/**
 * author: Google
 * id C39421CD-2A2D-4D92-B59B-69D70A328DF4
 * name finance
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/finance.svg
 * tags
 * - Banking 
 * - Math 
 */
export const ReportFinanceIcon = FinanceIcon;
export default ReportFinanceIcon